var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56078 3.70312C5.87093 3.70312 3.70508 5.86898 3.70508 8.55882V25.4403C3.70508 28.1302 5.87093 30.296 8.56078 30.296H17.7104V19.8999H14.9614V16.1569H17.7104V12.9591C17.7104 10.4468 19.3347 8.13999 23.0763 8.13999C24.5913 8.13999 25.7115 8.28542 25.7115 8.28542L25.6234 11.7807C25.6234 11.7807 24.4809 11.7699 23.2342 11.7699C21.8849 11.7699 21.6686 12.3916 21.6686 13.4237V16.1569H25.7306L25.5536 19.8999H21.6686V30.296H25.4422C28.1321 30.296 30.2979 28.1302 30.2979 25.4403V8.55885C30.2979 5.86901 28.1321 3.70315 25.4422 3.70315H8.56075L8.56078 3.70312Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.39568101363b8c3308f72f86a705fcf6.svg";
export { ForwardRef as ReactComponent };